import { render } from "./MobileProposalRow.vue?vue&type=template&id=537e54ae"
import script from "./MobileProposalRow.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileProposalRow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/MobileProposalRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "537e54ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('537e54ae', __exports__)) {
    api.reload('537e54ae', __exports__)
  }
  
  module.hot.accept("./MobileProposalRow.vue?vue&type=template&id=537e54ae", () => {
    api.rerender('537e54ae', render)
  })

}


export default __exports__